/**
 * 문자열 형식의 숫자를 검색합니다.
 * @example
 * searchStringNumbers("1234567890", "123") // true
 * searchStringNumbers("123-4567890", "123") // true
 * searchStringNumbers("123-4567890", "123-45") // true
 * searchStringNumbers("123-4567890", "123-45-67890") // true
 * searchStringNumbers("123-4567890", "999") // false
 */
export function searchStringNumbers(value: string, query: string): boolean {
  const normalizedValue = value.replace(/[^\d]/g, "")
  const normalizedQuery = query.replace(/[^\d]/g, "")

  if (!normalizedValue || !normalizedQuery) return false
  return normalizedValue.includes(normalizedQuery)
}
